<script setup lang="ts">
import type { BreadcrumbItem, BreadcrumbMobileDropdownMenuProps } from '.';

const props = defineProps<BreadcrumbMobileDropdownMenuProps>();

const isActive = shallowRef<boolean>(false);

function getItemKey(label: BreadcrumbItem['label']) {
	return `mobile-context-menu-item-${label}`;
}
</script>

<template>
	<DropdownMenu v-model:open="isActive">
		<DropdownMenuTrigger class="relative flex size-min">
			<IconPilarMoreHoriz class="size-4" />
		</DropdownMenuTrigger>

		<DropdownMenuContent
			align="start"
			prioritize-position
			class="flex min-w-10 flex-col gap-1 overflow-visible border border-white-dark-3 bg-white px-0 py-2 transition-all duration-300 ease-in-out"
		>
			<NuxtLink
				v-for="item in items"
				:key="getItemKey(item.label)"
				:to="item.route"
				class="flex w-full items-center self-stretch bg-white px-4 py-3 text-primary hover:bg-white-dark-1"
			>
				{{ item.label }}
			</NuxtLink>
		</DropdownMenuContent>
	</DropdownMenu>
</template>
